import { createSlice } from "@reduxjs/toolkit";

export const carSlice = createSlice({
  name: "car",
  initialState: {
    allCarBrands: [],
    allCarModels: [],
    allCarYears: [],
    selectedCar: { brand: null, model: null, year: null, carDetails: null },
  },

  reducers: {
    setAllCarBrands: (state, action) => {
      return { ...state, allCarBrands: action.payload };
    },
    setAllCarModels: (state, action) => {
      return { ...state, allCarModels: action.payload };
    },
    setAllCarYears: (state, action) => {
      return { ...state, allCarYears: action.payload };
    },
    setCarBrand: (state, action) => {
      return {
        ...state,
        selectedCar: {
          brand: action.payload,
        },
      };
    },
    setCarModel: (state, action) => {
      return {
        ...state,
        selectedCar: {
          ...state.selectedCar,
          model: action.payload,
        },
      };
    },
    setCarYear: (state, action) => {
      return {
        ...state,
        selectedCar: {
          ...state.selectedCar,
          year: action.payload,
          carDetails: null,
        },
      };
    },
    setCarDetails: (state, action) => {
      return {
        ...state,
        selectedCar: { ...state.selectedCar, carDetails: action.payload },
      };
    },
    resetCar: (state) => {
      return {
        ...state,
        selectedCar: { brand: null, model: null, year: null, carDetails: null },
      };
    },

    setSelectedCar: (state, action) => {
      return {
        ...state,
        selectedCar: action.payload,
      };
    },
  },
});

// action creators
export const {
  setAllCarBrands,
  setAllCarModels,
  setAllCarYears,
  setCarBrand,
  setCarModel,
  setCarYear,
  setCarDetails,
  resetCar,
  setSelectedCar,
} = carSlice.actions;

export default carSlice.reducer;
